export default __webpack_public_path__ + "static/media/04 Track 4.0e02846f.mp3";